module.exports = __webpack_public_path__ + "static/media/85x11no1.79b9c787.jpg";